<script>
    import QuestionTypes from '../lib/QuestionTypes';
    import {userMap} from '../Utilities/Session.svelte';

    export let control;
    export let model;
    export let assessment;
    export let domain = '';
    export let assessor = false;

    function getAnswer(control) {
        if (assessor) {
            return model.getAnswer(assessor, control.id, domain, assessment);
        } else {
            return model.getResult(control.id, domain, assessment);
        }
    }

    $: answer = getAnswer(control).value
    $: button = control.question_type == "free_text" ? null : QuestionTypes[control.question_type || "implementation_status"].buttons[answer]
</script>

{#if button}
<div class="control">
    <div class="tags has-addons">
        {#if assessor}
            <div class="tag">
                {$userMap[assessor] || assessor.split('@')[0].replace(".", " ")}
            </div>
        {:else}
            <div class="tag is-light is-info">
                Final Result
            </div>
        {/if}
        <div class="tag is-light {button.color}">
            {button.label}
        </div>
    </div>
</div>
{/if}
